import React, { useEffect } from 'react'
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom'
import { ToastContainer } from 'react-toastify'
import GrantListPage from './pages/GrantListPage'
import ProtectedRoute from './components/ProtectedRoute'
import AddWork from './pages/AddWork'
import { LoginPage } from './pages/LoginPage'
import { RegisterPage } from './pages/RegisterPage'
import DashBoard from './pages/DashBoard'
import { connect } from 'react-redux'
import { clearAuthState, restoreAuthState } from './store/slices'
import WorkAddPodcast from './pages/WorkAddPodcast'
import WorkAddPodcastEpisode from './pages/WorkAddPodcastEpisode'
import ResearcherList from './pages/ResearcherList'
import AddGrantPage from './pages/AddGrantPage'
import GrantDetails from './pages/GrantDetails'
import Settings from './pages/Settings'
import WorkDetails from './pages/WorkDetails'
import WorkList from './pages/WorkList'
import { store } from './store'
import EditGrantPage from './pages/EditGrantPage'
import EditWork from './pages/EditWork'

interface AppDispatchProps {
  restoreAuthState: () => void
}

type AppProps = AppDispatchProps

function AppComponent({ restoreAuthState }: AppProps): JSX.Element {
  useEffect(() => {
    restoreAuthState()

    document.addEventListener('session:expired', () => {
      store.dispatch(clearAuthState())
      localStorage.clear()
    })
  }, [])

  return (
    <div className="main">
      <Router>
        <Routes>
          <Route path="/" element={<Navigate to="/login" />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/register" element={<RegisterPage />} />
          <Route
            path="/grants"
            element={
              <ProtectedRoute>
                <GrantListPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/grants/add"
            element={
              <ProtectedRoute>
                <AddGrantPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/grants/:grantId/edit"
            element={
              <ProtectedRoute>
                <EditGrantPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/grants/:grantId/details"
            element={
              <ProtectedRoute>
                <GrantDetails />
              </ProtectedRoute>
            }
          />
          <Route
            path="/grants/:grantId/works"
            element={
              <ProtectedRoute>
                <WorkList />
              </ProtectedRoute>
            }
          />
          <Route
            path="/works"
            element={
              <ProtectedRoute>
                <WorkList />
              </ProtectedRoute>
            }
          />
          <Route
            path="/works/:workId/edit"
            element={
              <ProtectedRoute>
                <EditWork />
              </ProtectedRoute>
            }
          />
          <Route
            path="/grants/:grantId/works/add"
            element={
              <ProtectedRoute>
                <AddWork />
              </ProtectedRoute>
            }
          />
          <Route
            path="/works/add"
            element={
              <ProtectedRoute>
                <AddWork />
              </ProtectedRoute>
            }
          />
          <Route
            path="/works/:workId/details"
            element={
              <ProtectedRoute>
                <WorkDetails />
              </ProtectedRoute>
            }
          />
          <Route
            path="/settings"
            element={
              <ProtectedRoute>
                <Settings />
              </ProtectedRoute>
            }
          />
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <DashBoard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/researchers"
            element={
              <ProtectedRoute>
                <ResearcherList />
              </ProtectedRoute>
            }
          />
          <Route
            path="/podcast/add"
            element={
              <ProtectedRoute>
                <WorkAddPodcast />
              </ProtectedRoute>
            }
          />
          <Route
            path="/podcast/episode/add"
            element={
              <ProtectedRoute>
                <WorkAddPodcastEpisode />
              </ProtectedRoute>
            }
          />
          <Route path="*" element={<Navigate to="/login" replace />} />
        </Routes>
      </Router>
      <ToastContainer />
    </div>
  )
}

const mapDispatchToProps = (dispatch: any): AppDispatchProps => {
  return {
    restoreAuthState: () => dispatch(restoreAuthState()),
  }
}

export default connect(null, mapDispatchToProps)(AppComponent)
